import { render } from "./Campaign.vue?vue&type=template&id=205587b3"
import script from "./Campaign.vue?vue&type=script&lang=ts"
export * from "./Campaign.vue?vue&type=script&lang=ts"
script.render = render

export default script